import { zarazService } from "@/services";
import { useEffect } from "react";

export const useTrackProductViewed = (details: any, site: any) => {
  useEffect(() => {
    if(!details || details.isGenericProduct || !site) return;

    trackZaraz(details, site);
  }, [details, site]);
}

const trackZaraz = (details: any, site: any) => {
  zarazService.ecommerce.productViewed({
    product_id: details.id.toString(),
    sku: details.upcCode,
    category: details.categoryName,
    name: details.displayName,
    brand: site.name,
    price: details.rate,
    currency: 'usd',

    url: new URL(details.url, site.url).toString(),
    imageUrl: details.webImages.default.zoomed.url,
    comparePrice: details.baseRate,
    tags: details.tags
  });
}
